import {CargoItem} from "../../../interfaces/pagos.interface";
import {UserSessionReq} from "../../../../shared/interfaces/user-session-req-interface";
import {ProyectoItem} from "../../../interfaces/proyecto.interface";

export interface TramiteInterface {
    idTramite: number;
    nombreTramite: string;
    descripcionServicio: string;
    tipoServicio?: string,
    precioServicio?: number;
    requisitosServicio: tramiteRequisitos[];
}

export interface TramiteItem {
    codigoInstitucion: string;              // index: 0
    nombreInstitucion: string;              // index: 1
    idTramite: string;                      // index: 2
    nombreTramite: string;                  // index: 3
    tarifaTramite: string;                  // index: 4
    aplicaTarifario: boolean;               // index: 5
    idCategoria: string;                    // index: 6
    nombreCategoria: string;                // index: 7
    tipoTramite: string;                    // index: 8
    idFase: string;                         // index: 9
    nombreFase: string;                     // index: 10
    qtyglobal: number;                      // index: 11 qtyglobal=(qtyrequeridos+qtyopcionales)
    qtyrequeridos: number;                  // index: 12
    qtyopcionales: number;                  // index: 13
    qtycumplidos: number;                   // index: 14
    qtypendientes: number;                  // index: 15
    idProyecto?: number | null;             // index: 16
    idSolicitud: number;                    // index: 17
    idEstadoTramite?: number;               // index: 18
    orden: number;                          // index: 19
    tramiteEstado?: TramiteEstado | null;   // index: 20
    session?: UserSessionReq | null;        // index: 21
    formularioCompleto?: boolean | null;
    idsTramites?: number[]; //idsTramites para proceso de servicio expres
    tramiteExpres?:TramiteExpres
}

export interface TramiteMntDTO {
    idTramite: string;
    nombre: string;
    tarifa: string;
    idCategoria: string;
    aplicaTarifario: boolean;
    creadoPor?: string;
    modificadoPor?: string;
    idTipoTramite: string;
    estado?: boolean;
    idEstadoTramite?: number;
    idFase: string;
    nombreFase?: string;
    idInstitucion?: string;
    nombreInstitucion?: string;
    nombreCategoria?: string;
    cantGrupDet?: number;
    cantRqGlobal?: number;
    cantRqRequeridos?: number;
    idFormulario?: number;
    cantTarifarios?: number
}

export interface TramiteEstadoDTO {
    idTramite: string;
    modificadoPor?: string;
    estado?: boolean;
}

export interface TramiteGrpDTO {
    idTramiteGrp?: number;
    idsTramites?: number[];
    creadoPor?: string;
    modificadoPor?: string;
    estado?: boolean;
    uniqueId?: number;
    idSolicitudTipo: number;
}

export interface TramiteGrpDetReq {
    idTramiteGrp?: number;
    idTramites?: number[];
    creadoPor?: string;
}

export interface TramiteGrpResp {
    idTramiteGrpDet?: number;
    idTramiteGrp?: number;
    idTramite?: number;
    creadoPor?: string;
    modificadoPor?: string;
    estado?: boolean;
}

export interface TramiteGrpDetResp {
    idTramiteGrpDet: number;
    idTramiteGrp: number;
    idTramite: number;
    nombreTramite: string;
    creadoPor: string;
    modificadoPor: string;
    estado: boolean;
}

export interface TramiteGrp {
    idTramiteGrp: number;
    idTramiteGrpDet: number;
    idTramite: number;
    nombreTramite: string;
    estadoGrp: boolean;
    estadoGrpDet: boolean;
    uniqueId: number;
    idTipoFlujo?: number;
    cantidadTramites?: number;
    idSolicitudTipo: number;
}

export interface PagarTramiteInterface {
    codigoInstitucion: number;
    creadoPor: string | null | undefined;
    idTramite: number;
    idFase?: number;
    idProyecto?: number;
    pago: CargoItem;
}

export interface VaciarCarritoInterface {
    codigoInstitucion: number;
    creadoPor: string | null | undefined;
    idFase?: number;
    idProyecto?: number;
    idSolicitud?: number;
    idsTramites: number[]
}

export interface tramiteRequisitos {
    requisito: string
}

export interface InstitucionItem {
    idInstitucion: number;
    nombre: string;
    fechaCreacion: string;
    estado: boolean;
    permiteSeleccion: boolean;
    cantidadTramites: number;
}

export interface TramiteFormularioInstituciones {
    idInstitucion: number;
    codigoFormulario: number;
    nombreFormulario: string;
    rutaFormulario: string;
    fechaCreacion: string;
    estado: boolean;
}

export interface FrmItem {
    idFormulario: number;
    nombre: number;
    descripcion: string;
    ngRoute: string;
    estado: boolean;
}

export interface TramiteTabItem {
    label: string;
    IdInstitucion: number;
    icon: string;
    command: any
}

export interface FasesInterface {
    id: string;
    descripcion: string;
    estado: boolean;
}

export interface FasesTabItem {
    label: string;
    idFase: number;
    icon?: string;
    disabled: boolean
    command?: any
}

export interface NoFoundInterface {
    codigo: string;
    mensaje: string;
}

export interface TramiteRequisitosInterface {
    idRequisitoTipo: string;
    descripcion: Descripcion;
    estado: boolean;
    cantidadRequisitos: number;
    requisitos: Requisito[];
}

export enum Descripcion {
    Planos = "Planos",
    Resoluciones = "Resoluciones",
    Requisitos = "Requisitos",
}

export interface Requisito {
    idRequisito: string;
    idTramite: string;
    nombreRead?: string;//read
    nombre: string;//transactional
    descripcion: string;
    orden: string;
    estado: boolean;
    idRequisitoTipo: string;
    descripcionTipo?: Descripcion;
    estadoTipo?: boolean;
    cssIcono?: string;
    cssComponente?: string;
    aplicaCargaDocumento: boolean;
    aplicaFormulario?: boolean;
    idReqConfig?: CSSComponente;
    idTipoTramite?: string;
    idFormulario?: string;
    reqConstraints?: string | null;
    reqDefinition?: string | null;
    reqLabel?: string | null;
    reqName?: string | null;
    reqOptions?: string | null;
    reqTooltip?: string | null;
    reqType?: string | null;
    reqValue?: string | null;
}

export interface RequisitoOrden {
    orden: number;
    idRequisito: number;
}

export enum CSSComponente {
    Null = "null",
}

export interface TramiteEstado {
    idTramite: number | null;
    codigoEstado: number;
    btnAgregarTramiteEnCarrito: boolean;
    nombreEstado: string;
    color?: string;
}

export enum EstadoTramiteEnum {
    Eliminado = 0,
    EnCarrio = 1,
    FormularioPendiente = 2,
    FormularioCompleto = 3,
    PagoRealizado = 4,
    NoRequierePago = 5
}

export interface TramitesRequisitosInterface {
    idRequisitoTipo: string;
    descripcion: Descripcion;
    estado: boolean;
    cantidadRequisitos: number;
    requisitos: TramiteRequisito[];
}

export interface TramiteTipoRequisitoItem {
    idTipoTramite?: number;
    nombre?: string;
}

export interface TramiteRequisito {
    idTramiteRequisito?: number
    idRequisito: string;
    idTramite: string;
    nombre: string;
    descripcion: string;
    orden: number;
    estado: boolean;
    idRequisitoTipo: string;
    descripcionTipo: Descripcion;
    estadoTipo: boolean;
    cssIcono: CSSComponente;
    cssComponente: CSSComponente;
    aplicaCargaDocumento: boolean;
    aplicaFormulario: boolean;
    idTipoTramite: number;
    tipoTramite: string;
    opcional?: number | boolean;
    idReqConfig: CSSComponente;
}

// Interfaces para los requisitos del formulario
export interface TramiteRequisitosRqInterface {
    idRequisitoTipo: string;
    descripcion: Descripcion;
    estado: boolean;
    cantidadRequisitos: number;
    requisitos: TramiteRequisitoRq[];
}

export interface TramiteRequisitoRq {
    idRequisito: string;
    nombre: string;
    descripcion: string;
    estado: boolean;
    idRequisitoTipo: string;
    descripcionTipo?: Descripcion;
    estadoTipo: boolean;
    cssIcono?: CSSComponente;
    cssComponente?: CSSComponente;
    aplicaCargaDocumento: boolean;
    aplicaFormulario: boolean;
    idReqConfig?: CSSComponente;
    idArchivoEstadoRq: number;
    fechaModificacion?: string;
    totalRequisitos: number;
    totalRequisitosCumplidos: number;
    totalRequisitosObligatorios: number;
    opcional?: boolean;
    orden?: number
    reqName?: string,
    reqLabel?: string,
    reqTooltip?: string,
    reqType?: string,
    reqValue?: string,
    reqConstraints?: string,
    reqOptions?: string,
    reqDefinition?: string
    rqValue?: string,
    hash?: string,
    idTipoArchivo?: number,
    privado?: boolean,
    ext?: string
}

export interface ArchivoRequisitoInterface {
    creadoPor?: string,
    fechaCreacion?: string,
    idProyecto?: number,
    archivo?: string | File | null,
    hash?: string | undefined,
    nombreArchivo?: string,
    idTipoArchivo?: string | number,
    idTipoPersona?: string,
    idSolicitud?: string | number
    idArchivoProyecto?: string | number
    idRequisito?: string | number,
}

export interface SDetRq {
    usuario?: string,
    idProyecto?: string | number,
    idRequisito?: string | number
}

export interface InitPayload {
    p: ProyectoItem
    f: FasesTabItem[];
    tf: TramiteItem[];
}

export interface TrafifarioPorTramiteInterface {
    idTarifario: number,
    idEntorno: number,
    idTramite: number,
    idTipoArea: number,
    montoBase: number,
    areaDesde: number,
    areaHasta: number,
    factor1: number,
    factor2: number,
    formulaDescripcion: string,
    estado: boolean,
    entorno: string,
    tramite: string,
    tipoArea: string
}

export interface TarifarioMantenimientoInterface {
    idTarifario: number,
    idEntorno?: number | null,
    idTramite: number | null,
    idTipoArea?: number | null,
    idTarifarioTipo: number,
    montoBase: number,
    areaDesde: number,
    areaHasta: number,
    factor1: number,
    factor2: number,
    formulaDescripcion: string,
    estado: boolean,
    creadoPor?: string,
    modificadoPor?: string
    idTarifarioFormula?:number
}

export interface TarifarioTipoInterface {
    id: number,
    descripcion: string,
    estado: boolean,
    regulado: boolean
}

export interface FormulaInterface {
    idTarifarioFormula: string,
    descripcion: string,
    estado: boolean,
    regulado: boolean
}

export interface TramitesRequisitos {
    idTramiteRequisito?: number,
    idTramite: number,
    estado: boolean,
    orden: number,
    opcional: boolean,
    idsRequisito: number[]
}

export interface TramiteRequisitoEstado {
    idTramiteRequisito: number;
    estado: boolean;
}

export interface TramiteRequisitoOrden {
    idTramiteRequisito?: number
    orden: number;
    idTramite: number;
    idRequisito: number;
}

export interface TramitesRequisitosSeleccionados {
    idsTramitesRequisitos: number[],
    estado: boolean
}

export interface TarifarioEstadoDTO {
    idTarifario: number;
    modificadoPor?: string;
    estado?: boolean;
}

export interface RequisitoOrden {
    orden: number;
    idRequisito: number;
}

export interface ArchivosHabilitarRq {
    idProyecto: number;
    idSolicitud: number;
    idsRequisito: number[];
    session?: UserSessionReq;
    descripcion: string;
}
export enum CategoriaTramiteEnum {
    ServiciosOnline = 1,
    ServicioOnlineTramiteExpresIndividual = 2,
    ServicioOnlineExpresporTramiteIntegrado = 3
}

export interface TramiteExpres {
    idTramiteExpres?: number | null;
    idCategoria?: number | null;
    nombreTramiteExpres?: string | null;

}
